import type { RecipeVariants } from '@vanilla-extract/recipes'
import type { PropsWithChildren } from 'react'
import { capitalize } from '#lib/utils/strings'
import { DeploymentStatusIcon } from '../deployments/deployment-status-icon'
import { pillStyle } from './pill.css'

type PillProps = PropsWithChildren<{
  color?: NonNullable<RecipeVariants<typeof pillStyle>>['color']
  reverse?: NonNullable<RecipeVariants<typeof pillStyle>>['reverse']
  singleChar?: NonNullable<RecipeVariants<typeof pillStyle>>['singleChar']
}>

export const PillCheckStatus = ({
  checkStatus,
}: {
  checkStatus: 'PASS' | 'FAIL'
}) => {
  return (
    <span title={capitalize(checkStatus)}>
      {checkStatus === 'FAIL' && <DeploymentStatusIcon icon="failed" />}
      {checkStatus === 'PASS' && <DeploymentStatusIcon icon="succeeded" />}
      {checkStatus !== 'FAIL' && checkStatus !== 'PASS' && (
        <Pill color={'neutral'}>Unknown status</Pill>
      )}
    </span>
  )
}

export function Pill({
  children,
  color,
  singleChar = false,
  reverse = false,
}: PillProps) {
  return (
    <span
      className={pillStyle({
        color,
        singleChar,
        reverse,
      })}
    >
      {children}
    </span>
  )
}
